import { DYNAMIC_MODULES_ENV, DYNAMIC_MODULES_ORIGIN } from '../../config';
import { DYNAMIC_MODULES_COMMON_SCOPE, DynamicModulesConfigMap, DynamicModuleSlug } from './dynamic-modules.types';

const COMMON_DYNAMIC_MODULES_CONFIG_PATH = '/fe/api/common/dynamic-modules';

type DynamicModulesFetchResult = DynamicModulesConfigMap | { error: string } | null;

function isValidResponse(response: DynamicModulesFetchResult): response is DynamicModulesConfigMap {
  return response !== null && typeof response === 'object' && !('error' in response);
}

function genDynamicModulePath(slug: DynamicModuleSlug, fileName: string): string {
  return `dynamic-modules/${DYNAMIC_MODULES_ENV}/${DYNAMIC_MODULES_COMMON_SCOPE}/${slug}/${fileName}`;
}

async function importDynamicModule<T>(modulePath: string): Promise<T | null> {
  const module = await import(/* webpackIgnore: true */ `${DYNAMIC_MODULES_ORIGIN}/static/${modulePath}`);
  return module.default;
}

export async function fetchCommonDynamicModulesConfig(): Promise<DynamicModulesConfigMap | null> {
  const response = await fetch(`${DYNAMIC_MODULES_ORIGIN}${COMMON_DYNAMIC_MODULES_CONFIG_PATH}`);
  const result = (await response.json()) as DynamicModulesFetchResult;
  return isValidResponse(result) ? result : null;
}

// a tombstone config ("name": null) switches the module off
export async function initDynamicModule<T>(slug: DynamicModuleSlug, configMap: DynamicModulesConfigMap) {
  const entrypointName = configMap[genDynamicModulePath(slug, 'config.json')]?.config.name;
  return entrypointName ? importDynamicModule<T>(genDynamicModulePath(slug, entrypointName)) : null;
}
